import { render, staticRenderFns } from "./CardsListWithIcon.vue?vue&type=template&id=4ea6fcde&scoped=true&"
import script from "./CardsListWithIcon.vue?vue&type=script&lang=ts&"
export * from "./CardsListWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CardsListWithIcon.vue?vue&type=style&index=0&id=4ea6fcde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6fcde",
  null
  
)

export default component.exports